<template>
  <div class="bg-blue-200 select-none">
    <div class="px-4 pb-4 pt-3 max-w-6xl mx-auto flex flex-col items-start justify-start min-h-screen">
      <div class="flex items-center justify-between w-full mb-4">
        <a href="/profile">
          <img
            src="/img/logo-yuk-belajar-optimized.png"
            class="h-full sm:hidden">
          <img
            src="/img/logo-dan-nama-yuk-belajar.png"
            class="h-14 hidden sm:block">
        </a>
      </div>
      <div class="bg-white shadow-md rounded w-full flex-grow flex flex-col items-start justify-start p-4">
        <div class="flex-grow w-full mx-auto leading-tight font-serif text-gray-900">
          <div class="font-bold text-2xl mb-5 p-3 text-center">
            Kunci Jawaban {{ module_name }}
          </div>
          <div
            v-show="!finished"
            class="w-64 text-blue-300 mx-auto my-auto">
            <svg
              class="fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"><path d="M218.1,167.17c0,13,0,25.6,4.1,37.4-43.1,50.6-156.9,184.3-167.5,194.5a20.17,20.17,0,0,0-6.7,15c0,8.5,5.2,16.7,9.6,21.3,6.6,6.9,34.8,33,40,28,15.4-15,18.5-19,24.8-25.2,9.5-9.3-1-28.3,2.3-36s6.8-9.2,12.5-10.4,15.8,2.9,23.7,3c8.3.1,12.8-3.4,19-9.2,5-4.6,8.6-8.9,8.7-15.6.2-9-12.8-20.9-3.1-30.4s23.7,6.2,34,5,22.8-15.5,24.1-21.6-11.7-21.8-9.7-30.7c.7-3,6.8-10,11.4-11s25,6.9,29.6,5.9c5.6-1.2,12.1-7.1,17.4-10.4,15.5,6.7,29.6,9.4,47.7,9.4,68.5,0,124-53.4,124-119.2S408.5,48,340,48,218.1,101.37,218.1,167.17ZM400,144a32,32,0,1,1-32-32A32,32,0,0,1,400,144Z" /></svg>
          </div>
          <div
            v-for="section in $store.state.questionBySection"
            :key="section.id"
            class="mb-16">
            <div class="font-bold text-xl mb-5 p-3 bg-blue-600 text-white text-center">
              {{ section.name }}
            </div>
            <div
              v-for="(question, i) in section.questions"
              :key="question.id.toString() + i.toString()"
              class="mt-3 mb-8">
              <div class="flex items-center justify-start">
                <div class="mb-1 font-semibold w-full">
                  Soal Nomor {{ i+1 }}
                </div>
              </div>
              <div
                v-if="question.reference != null && ((section.questions[i-1] == undefined) || (section.questions[i-1] != undefined && ((section.questions[i-1].reference == null) || (section.questions[i-1].reference != null && section.questions[i-1].reference.id != question.reference.id))))"
                class="flex flex-col items-start justify-start">
                <div class="flex items-center justify-start">
                  <div class="mb-1 font-semibold w-full">
                    Konteks
                  </div>
                </div>
                <div
                  class="reference"
                  v-html="removeLink(question.reference.content)" />
              </div>
              <div
                class="question mb-2"
                v-html="removeLink(question.content)" />
              <div class="answer mb-4" v-if="section.type == 'multiple'">
                <div
                  v-for="(answer, j) in question.answers"
                  :key="answer.id.toString() + j.toString()">
                  <div
                    class="mb-2 flex items-center justify-start"
                    :class="{'text-green-600 font-semibold': answer.is_solution}">
                    <div class="flex items-center justify-start">
                      <div class="w-5 mr-2">
                        {{ answerChars[j] }}
                      </div>
                    </div>
                    <div
                      class="w-full"
                      v-html="removeLink(answer.content)" />
                  </div>
                </div>
              </div>
              <div class="mb-1 font-semibold">
                Pembahasan Soal Nomor {{ i+1 }}
              </div>
              <div
                v-if="question.solution != null"
                class="mb-5 solution"
                v-html="removeLink(question.solution)" />
              <div
                v-else
                class="italic mb-5">
                -
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['module_name'],
  data: function() {
    return {
      answerChars: ['A.', 'B.', 'C.', 'D.', 'E.'],
      finished: false
    };
  },
  computed: {},
  watch: {},
  async mounted() {},
  created() {},
  updated() {
    this.$nextTick(function () {
      this.finished = true;
    })
  },
  methods: {
    removeLink(htmlString) {
      return htmlString.replace(/<a\b[^>]*>/g,'').replace(/<\/a>/g, '');
    },
    print() {
      window.print();
    },
  }
}
</script>
<style>
    .attachment__caption {
        display: none;
    }
    .question figure.attachment, .reference figure.attachment, .solution figure.attachment {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }
    .question div, .solution div, .reference div {
        margin-bottom: 0.75rem;
    }
</style>
